// extracted by mini-css-extract-plugin
export default {"mainCard":"reset_mainCard__sOBOf","input":"reset_input__G7Ay4","eyeIcon":"reset_eyeIcon__nLTYV","crossIcon":"reset_crossIcon__EZe+7","ctaBtn":"reset_ctaBtn__ywRaa"};